/**
 * @internal
 */
export var TIME_PERIOD_FIELDS = [
    'year',
    'month',
    'week',
    'day',
    'hour',
    'minute',
    'second',
    'millis',
];
export var timePeriod = function () { return ({
    year: 0,
    month: 0,
    week: 0,
    day: 0,
    hour: 0,
    minute: 0,
    second: 0,
    millis: 0,
}); };
/**
 * @internal
 */
export var TIME_FLAGS = 16 /* TimePeriodFieldFlag.HOUR */ | 32 /* TimePeriodFieldFlag.MINUTE */ | 64 /* TimePeriodFieldFlag.SECOND */ | 128 /* TimePeriodFieldFlag.MILLIS */;
var FIELDMAP = {
    year: 1 /* TimePeriodFieldFlag.YEAR */,
    month: 2 /* TimePeriodFieldFlag.MONTH */,
    week: 4 /* TimePeriodFieldFlag.WEEK */,
    day: 8 /* TimePeriodFieldFlag.DAY */,
    hour: 16 /* TimePeriodFieldFlag.HOUR */,
    minute: 32 /* TimePeriodFieldFlag.MINUTE */,
    second: 64 /* TimePeriodFieldFlag.SECOND */,
    millis: 128 /* TimePeriodFieldFlag.MILLIS */,
};
/**
 * @internal
 */
export var timePeriodFieldFlags = function (fields) {
    var flags = 0;
    var smallest = 128 /* TimePeriodFieldFlag.MILLIS */;
    if (fields) {
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var field = fields_1[_i];
            var flag = FIELDMAP[field];
            if (flag) {
                flags |= flag;
                smallest = flag;
            }
        }
    }
    return [flags, smallest];
};
//# sourceMappingURL=interval.js.map